import { createTheme } from '@material-ui/core/styles';

import * as styleVariables from './variables.module.scss';

export const darkTheme = createTheme({
  palette: {
    primary: {
      main: styleVariables.darkBlue,
    },
    text: {
      secondary: styleVariables.darkishGrey,
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: styleVariables.white,
    },
    text: {
      secondary: styleVariables.white,
    },
  },
});
